<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="What other services are available?" /></div>
    </div>
    <BLoading :active.sync="properties.loadingStatus.isLoading" />
    <div v-if="!properties.loadingStatus.isLoading">
      <div class="columns text-content">
        <div class="column is-6">
          <p v-if="hasEligibleProperties">
            Please select the address you’d like to view services for:
          </p>
          <LsInfoCard v-else>
            <p>
              Please wait until your lawn mowing service has been assigned to a crew before ordering
              additional services.
            </p>
          </LsInfoCard>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div v-for="property in eligibleProperties" :key="property.property_id" class="item">
            <LsAddressCard :property="property" />
            <RouterLink
              :to="{
                name: 'orderService',
                params: { property_id: property.property_id },
              }"
              class="order-service"
            >
              <LsButton
                class="view-services"
                text="view services"
                test-id="view_services"
                track-id="what_other_services_view-view_services"
                bg-color="primary-light"
                text-color="primary"
              />
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton, LsAddressCard, LsInfoCard } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { PROPERTIES__GET_PROPERTIES_AND_SCHEDULES } from '@/store/types';
import _ from 'lodash';
import { LsSupportHeader } from '../components';

export default {
  name: 'WhatOtherServicesView',
  components: {
    LsButton,
    LsAddressCard,
    LsInfoCard,
    LsSupportHeader,
  },
  computed: {
    ...mapState(['properties']),
    eligibleProperties() {
      return _.pickBy(
        this.properties.propertiesById,
        (property) => property.can_request_additional_services
      );
    },
    hasEligibleProperties() {
      return !_.isEmpty(this.eligibleProperties);
    },
  },
  created() {
    this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
  },
  methods: {
    ...mapActions([PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
  },
};
</script>

<style lang="scss" scoped>
.text-content {
  margin-bottom: 20px;
}

.item {
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid $primary-light;
  display: flex;
  justify-content: space-between;
}

.order-service {
  align-self: center;
}

@media (max-width: $mobile-max-width) {
  .item {
    flex-direction: column;
  }

  .view-services {
    margin-top: 30px;
  }

  .order-service {
    align-self: auto;
  }
}
.themed-app {
  .item {
    border-color: $theme-color-primary-light;
  }
}
</style>
